import {
    MODE_UPDATE_MUTATION
} from './_store/config';
import * as TYPES from '@/components/search-result/_store/types';
import util from '../../common/util';
import { usePageStore } from '@/store'

import { localStorageSortKey } from './_conf';
import {
    getListingSource,
    asyncData as searchBarAsyncData
} from '../md-search-bar/asyncData';
import { getQueryWithDecodeKey } from '@/clientEnv';
import {
    getMarketChangeValue,
    asyncData as searchResultData
} from '@/components/search-result/asyncData';

function setSortConfigs(store, sortConfigs) {
    if (!sortConfigs || sortConfigs.length === 0) {
        return;
    }
    store[TYPES.SET_SORT_CONFIGS](sortConfigs);
    let _sortConfigs = sortConfigs.filter(sort => sort.show !== false);
    store[TYPES.SORT_UPDATE_MUTATION](
        _sortConfigs.length === 0 ? 'RELEVANCE' : _sortConfigs[0].value
    );
}
function processSortConfig(store, query) {
    let sortConfigs;
    if (query.listingSortOptions) {
        sortConfigs = util.parseJSON(query.listingSortOptions);
    } else {
        sortConfigs = this.sortConfigs;
    }
    if (!sortConfigs) {
        const listingSource = store.listingSource;
        if (
            listingSource === 'sold listings' ||
            listingSource.startsWith(`${store.soldListingFlag}+`)
        ) {
            sortConfigs = [
                {
                    label: 'Default',
                    value: 'RELEVANCE'
                },
                {
                    label: 'Most Recent',
                    value: 'MLS_LIST_DATE_L_DESC'
                },
                {
                    label: 'Price-Highest',
                    value: 'PRICE_DESC'
                },
                {
                    label: 'Price-Lowest',
                    value: 'PRICE_ASC'
                },
                {
                    label: 'Beds (Most)',
                    value: 'BEDROOMS_DESC'
                },
                {
                    label: 'Baths (Most)',
                    value: 'BATHS_DESC'
                },
                {
                    label: 'Year Built (Newest)',
                    value: 'BUILT_YEAR_DESC'
                }
            ];
        } else {
            sortConfigs = [
                {
                    label: 'Default',
                    value: 'RELEVANCE'
                },
                {
                    label: 'Price-High To Low',
                    value: 'PRICE_DESC'
                },
                {
                    label: 'Price-Low To High',
                    value: 'PRICE_ASC'
                },
                {
                    label: 'Newest Listings',
                    value: 'MLS_LIST_DATE_L_DESC'
                },
                {
                    label: 'Beds (Most)',
                    value: 'BEDROOMS_DESC'
                },
                {
                    label: 'Baths (Most)',
                    value: 'BATHS_DESC'
                },
                {
                    label: 'Year Built (Newest)',
                    value: 'BUILT_YEAR_DESC'
                },
                {
                    label: 'Square Feet (Biggest)',
                    value: 'SQFT_DESC'
                }
            ];
        }
    }
    setSortConfigs.call(this, store, sortConfigs);
}
// function computedMode(isMobileSize) {
//     if (isMobileSize) {
//         return this.mobileMode || 'grid';
//     } else {
//         return this.mode || 'grid';
//     }
// }

// function initMode(context) {
//     let { commit } = context;
//     const isMobileSize = this.platform.isMobile;
//     const tempMode = computedMode.call(this, isMobileSize);
//     const mode = tempMode.split('+');
//     commit(MODE_UPDATE_MUTATION, {
//         isMobile: isMobileSize,
//         layout: this.searchModuleType === 'big-map' ? 'map' : mode[0] || 'grid',
//         mapType: (mode[0] === 'map' && mode[1]) || null
//     });
//     if (this.searchModuleType && this.searchModuleType === 'grid-list') {
//         commit(TYPES.GRID_OR_LIST_TYPE_MUTATION, tempMode);
//     }
// }
export function processViewPattern(store, query) {
    // const searchModuleType = state.searchModuleType;
    const isMobileSize = this.platform.isMobile;
    if (query.layoutType) {
        if (query.layoutType === 'map') {
            store[MODE_UPDATE_MUTATION]({
                isMobile: isMobileSize,
                mode: `${query.layoutType}+${query.mapType}`
            });
        } else {
            store[MODE_UPDATE_MUTATION]({
                isMobile: isMobileSize,
                mode: `${query.mapType}`
            });
        }
    } else if (query.mode) {
        store[MODE_UPDATE_MUTATION]({
            isMobile: isMobileSize,
            mode: query.mode
        });
        delete query.mode;
    } else {
        const tempMode = isMobileSize ? this.mobileMode : this.mode;
        store[MODE_UPDATE_MUTATION]({
            isMobile: isMobileSize,
            mode: tempMode || 'grid'
        });
    }
    // let layout, gridOrListType;
    // if (getters.onlyGridOrList){
    //     layout = 'normal';
    //     if (query.mode) {
    //         delete query.mode;
    //     }
    //     if (query.gridOrListType){
    //         gridOrListType = query.gridOrListType;
    //     }
    // }
    // else {

    // }

    
    
    // if (searchModuleType) {
    //     if (searchModuleType === 'grid-list' && query.gridOrListType) {
    //         this.mode = this.mobileMode = query.gridOrListType;
    //         delete query.gridOrListType;
    //     }
    //     if (query.mode) {
    //         delete query.mode;
    //     }
    // } else {
    //     let viewPattern =
    //         util.isSSRServer
    //             ? undefined
    //             : util.getStorageItemExpires(localStorageViewPatternKey());
    //     if (viewPattern) {
    //         this.mode = this.mobileMode = viewPattern;
    //     }
    //     if (query.layoutType) {
    //         this.mode = this.mobileMode =
    //             query.layoutType + (query.mapType ? '+' + query.mapType : '');
    //         delete query.layoutType;
    //         delete query.mapType;
    //     }
    //     if (query.mode) {
    //         this.mode = this.mobileMode = query.mode;
    //         if (/insight/.test(query.mode)) {
    //             commit(TYPES.PREV_VIEW_PATTERN_MUTATION, {
    //                 layout: 'map',
    //                 mapType: 'list'
    //             });
    //             if (query.mode === 'insight' && !isMobileSize) {
    //                 this.mode = 'map+insight';
    //             }
    //         } else {
    //             delete query.mode;
    //         }
    //     }
    //     if (query.gridOrListType) {
    //         delete query.gridOrListType;
    //     }
    // }

    // initMode.call(this, context);
}

function processSort(store, query) {
    if (query.sort || query.listingSort) {
        store[TYPES.SORT_UPDATE_MUTATION](query.sort || query.listingSort);
        delete query.sort;
        delete query.listingSort;
    } else {
        let sort = util.isSSRServer
            ? undefined
            : util.getStorageItemExpires(localStorageSortKey());
        if (sort) {
            store[TYPES.SORT_UPDATE_MUTATION](sort);
        }
    }
}
export function getRequestType(store) {
    const { mapCondition } = store;
    const isBigMap = store.isBigMap;
    const isGridOrList = store.isGridOrList;
    // const { mobileMode } = this;
    // const isMobileSize = this.platform.isMobile;
    const layout = store.layout;
    if (isBigMap) {
        return {
            mapOnly: true,
            listOnly: false
        };
    } else if (isGridOrList) {
        return {
            mapOnly: false,
            listOnly: true
        };
    } else {
        return {
            listOnly: layout === 'normal' || layout === 'mixed',
            mapOnly: (mapCondition.rect || mapCondition.mapPath) && (layout === 'map' || layout === 'mixed')
        }; 
    }
    // let listOnly = false;
    // let mapOnly = false;
    // if (layout === 'map' && (mapCondition.rect || mapCondition.mapPath)) {
    //     mapOnly = true;
    // }
    // if (
    //     (layout === 'map' && mapType) ||
    //     layout === 'grid' ||
    //     layout === 'list'
    // ) {
    //     listOnly = true;
    // }
    // if (mobileMode === 'insight' && isMobileSize) {
    //     listOnly = true;
    // }
    // return {
    //     listOnly,
    //     mapOnly
    // };
}
export async function conditionChange(store, params) {
    let { condition, type, kee, init } = params;
    if (['mapPath', 'mapSearch', 'mapRadius'].includes(kee)) {
        return; 
    }
    condition = JSON.parse(JSON.stringify(condition))
    delete condition.listingSource;
    if (!init) {
        store[TYPES.PAGE_CHANGE_MUTATION]({ page: 1 });
    }
    store[TYPES.UPDATE_SEARCH_PARAMS](condition);
    if (!type) {
        type = getRequestType.call(this, store);
    }
    if (util.isSSRServer) {
        await Promise.all([
            getMarketChangeValue.call(this, store, params),
            store[TYPES.SEARCH_DATA_ACTION]({
                ...type,
                isMobile: this.platform.isMobile
            })
        ]);
    } else {
        setTimeout(() => {
            store[TYPES.SEARCH_DATA_ACTION]({ 
                ...type,
                isMobile: this.platform.isMobile
            });
            getMarketChangeValue.call(this, store, params);
        }, 0);
    }
}

export async function asyncData(store) {
    let { page: globalData } = usePageStore(this.$pinia);
    let query = getQueryWithDecodeKey(globalData);
    await getListingSource.call(this, store, { query });
    processSortConfig.call(this, store, query);
    processViewPattern.call(this, store, query);
    processSort.call(this, store, query);
    await searchBarAsyncData.call(this, store);
    await searchResultData.call(this, store);
    const searchParamsWithMap = store.searchParamsWithMap;
    const params = {
        init: true,
        oldValue: null,
        kee: null,
        value: searchParamsWithMap,
        condition: { ...searchParamsWithMap }
    };
    await conditionChange.call(this, store, params);
}